module.exports = __webpack_public_path__ + "static/media/status_canceled.44e3b835.svg";